export default __webpack_public_path__ + "static/mellowgolemgames-7d461b4da0fb80c75a3c7147b5806a54.png";